import Box from '@eversports/klimt-primitives/legacy/Box'
import CircularProgress from '@eversports/klimt-primitives/legacy/CircularProgress'

const MapLoadingWrapper = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      backgroundColor: 'lightgray',
    }}
  >
    <CircularProgress sx={{ margin: '0 auto' }} />
  </Box>
)

export default MapLoadingWrapper
